/**
 * Constants for asset URLs used throughout the application
 * This centralizes all hardcoded URLs for better maintainability
 */
export const ASSET_URLS = {
  // Blog related assets
  BLOG_ICON:
    'https://images.ctfassets.net/6huuyzvsw0nv/3aJZngNGd7KNgmumiPjGkV/9d4e8b4ee24dd2e639bbe86a18b85fe1/icon-one-pager.svg',
  SHARE_ICON:
    'https://images.ctfassets.net/6huuyzvsw0nv/3xALDUjt2zqLP9kKtLNai3/668e8cb3a3caac958e17508d14be1b5b/share-icon.svg',
  DEFAULT_BLOG_IMAGE:
    'https://images.ctfassets.net/6huuyzvsw0nv/72vnmgGILPdL5TegoxPCqk/f6bf8de3c2f72e89cf2c2e21f59ec6a4/blog-pdf-header.png',

  // Social media icons
  FACEBOOK_ICON:
    'https://images.ctfassets.net/6huuyzvsw0nv/facebook-icon/facebook-icon.svg',
  TWITTER_ICON:
    'https://images.ctfassets.net/6huuyzvsw0nv/twitter-icon/twitter-icon.svg',
  LINKEDIN_ICON:
    'https://images.ctfassets.net/6huuyzvsw0nv/linkedin-icon/linkedin-icon.svg',

  // Other common assets
  LOGO: 'https://images.ctfassets.net/6huuyzvsw0nv/logo/logo.svg',
  FAVICON: 'https://images.ctfassets.net/6huuyzvsw0nv/favicon/favicon.ico',
};
